import React from "react";
import { Tooltip, Alert } from "antd";
import { Box, LinearProgress, Stack, Pagination } from "@mui/material";

export default function TabelaOutrosDocs({
  loadingDocumentos,
  paginationArquivosNaoObrigatorios,
  loadings,
  info,
  FloatButtonVisualizar,
  FloatButtonDownload,
  FloatButtonDelete,
  handleVisualizarArquivo,
  downloadDocumento,
  showModalExcluirArquivo,
}) {
  return (
    <div className="border">
      {loadingDocumentos ? (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      ) : Array.isArray(paginationArquivosNaoObrigatorios) &&
        paginationArquivosNaoObrigatorios.length > 0 ? (
        paginationArquivosNaoObrigatorios.map((file, index) => (
          <div key={index}>
            <div className="files format-file style-bkg">
              <div style={{ padding: 20, width: "100%" }}>
                {file.nome.length > 35
                  ? `${file.nome.slice(0, 35)}...`
                  : file.nome}
              </div>

              <div className="float-buttons">
                {file.nome?.toLowerCase().endsWith(".json") && (
                  <Tooltip title="Visualizar">
                    <div
                      className="float-button-delete format-btn"
                      onClick={() => handleVisualizarArquivo(file)}
                    >
                      <FloatButtonVisualizar />
                    </div>
                  </Tooltip>
                )}

                <Tooltip title="Download">
                  <div
                    loading={loadings[index]}
                    className="float-button-download format-btn"
                    onClick={() => downloadDocumento(info.id, file.nome)}
                  >
                    <FloatButtonDownload />
                  </div>
                </Tooltip>

                <Tooltip title="Excluir">
                  <div
                    className="float-button-delete format-btn"
                    onClick={() => showModalExcluirArquivo(file)}
                  >
                    <FloatButtonDelete />
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="alert-message">
          <Alert
            message="Nenhum documento disponível."
            type="info"
            showIcon
          />
        </div>
      )}
    </div>
  );
}
